import { api_base_url, request } from '../utils';

const BASE = (api_base_url || '').replace(/\/+$/, '');

export class ScoreService {
  static ENDPOINT = `${BASE}/score`;

  static async get(id) {
    return await request({
      url: `${this.ENDPOINT}/${encodeURIComponent(id)}`,
      headers: {'Accept': 'application/json'}
    })
  }
}

export default ScoreService;
